<template>
    <div>
        <div class="vld-parent" v-if="isLoading">
            <loading
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="true"
                loader="dots"
            ></loading>
        </div>
        <div v-if="!isSubmitted">
            <CRow>
                <CCol sm="1"></CCol>
                <CCol sm="10">
                    <CCard class="topContainer">
                        <CCardBody class="cardBody">
                            <p class="headerText my-auto">
                                Employee Onboarding
                            </p>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol sm="1"></CCol>
            </CRow>
            <CRow>
                <CCol sm="2"></CCol>
                <CCol>
                    <h5 :class="isBasic ? 'blueText' : 'whiteText'">
                        1. THE BASICS
                    </h5>
                    <hr :class="isBasic ? 'blueRuler' : 'whiteRuler'" />
                </CCol>
                <CCol>
                    <h5 :class="isBankInfo ? 'blueText' : 'whiteText'">
                        2. CRYPTO INFORMATION
                    </h5>
                    <hr :class="isBankInfo ? 'blueRuler' : 'whiteRuler'" />
                </CCol>
                <CCol>
                    <h5 :class="isOthers ? 'blueText' : 'whiteText'">
                        3. OTHER DETAILS
                    </h5>
                    <hr :class="isOthers ? 'blueRuler' : 'whiteRuler'" />
                </CCol>
                <CCol sm="2"></CCol>
            </CRow>
            <CRow v-if="isBasic">
                <CCol sm="2"></CCol>
                <CCol>
                    <span class="textStyle"
                        >Is this an employee or a contractor?</span
                    >
                    <br />
                    <input
                        type="radio"
                        id="Employee"
                        value="Employee"
                        v-model="isEmployee"
                    />
                    <label class="space20pad" for="Employee">Employee</label>
                    <br />
                    <input
                        type="radio"
                        id="Contractor"
                        value="Contractor"
                        v-model="isEmployee"
                    />
                    <label class="space20pad" for="Contractor"
                        >Contractor</label
                    >
                    <br />
                    <CInput
                        label="Name"
                        placeholder="Enter name "
                        :value.sync="name"
                    />
                    <CInput
                        label="Email"
                        placeholder="Enter email address"
                        :value.sync="email"
                        description="The email they will use to log into Raftel. If this person does not have an email address, click here to generate one for them."
                        addInputClasses="DashboardDescription"
                    />
                    <CInput
                        label="Joining Date"
                        placeholder=""
                        type="date"
                        :value.sync="joinDate"
                        description="The first day of employment for this person."
                        addInputClasses="DashboardDescription"
                    />
                    <CInput
                        label="Job Title"
                        :value.sync="jobTitle"
                        placeholder="Enter job title"
                    />
                    <CInput
                        label="Employee ID"
                        placeholder=""
                        type="number"
                        :value.sync="employeeId"
                        description="Enter only the numeric part of the employee id."
                        addInputClasses="DashboardDescription"
                    />
                    <CInput
                        label="Department"
                        :value.sync="department"
                        placeholder="Enter Department"
                    />
                    Manager
                    <br /><br />
                    <select
                        class="selectClass"
                        @change="onManagerChange($event)"
                    >
                        <option disabled value="">Please select Manager</option>
                        <option>Amala David</option>
                        <option>Balaji</option>
                    </select>

                    Select Country
                    <br /><br />
                    <select
                        class="selectClass"
                        @change="onCountryChange($event)"
                    >
                        <option disabled value="">Country</option>
                        <option>India</option>
                        <option>US</option>
                    </select>
                </CCol>
                <CCol sm="3"></CCol>
            </CRow>
            <CRow v-if="isBankInfo">
                <CCol sm="2"></CCol>
                <CCol>
                    <CCard class="topContainer">
                        <CCardBody class="cardBody">
                            <span style="font-size:15px;">
                                Please be very careful while entering data on
                                this screen. Mistakes will lead to wrong salary
                                transfers.</span
                            >
                        </CCardBody>
                    </CCard>
                    <CInput
                        label="ETH Wallet address"
                        placeholder="Enter Wallet address "
                        :value.sync="walletAddress"
                        description="This is the wallet which the employee will be using to receive the salary in crypto"
                        addInputClasses="DashboardDescription"
                    />
                    <CInput
                        placeholder="Confirm Wallet address"
                        description="Please enter the wallet address again"
                        addInputClasses="DashboardDescription"
                    />

                    Payment Frequency
                    <br /><br />
                    <select
                        class="selectClass"
                        @change="onPaymentFrequencyChange($event)"
                    >
                        <option disabled value="">Default</option>
                        <option>Daily </option>
                        <option>Weekly</option>
                        <option>Monthly</option>
                    </select>
                    Preferred Currency
                    <br /><br />
                    <select
                        class="selectClass"
                        @change="onPreferredCurrencyChange($event)"
                    >
                        <option disabled value="">Default</option>
                        <option>ETH</option>
                        <option>USDT </option>
                        <option>USDC</option>
                        <option>DAI</option>
                    </select>
                    <CInput
                        label="Amount"
                        placeholder="Please enter the amount details"
                        type="number"
                        :value.sync="amount"
                        addInputClasses="DashboardDescription"
                    />
                </CCol>
                <CCol sm="3"></CCol>
            </CRow>
            <CRow v-if="isOthers">
                <CCol sm="2"></CCol>
                <CCol>
                    <CInput
                        label="Date of Birth"
                        :value.sync="dateOfBirth"
                        placeholder=""
                        type="date"
                    />
                </CCol>
                <CCol sm="3"></CCol>
            </CRow>
            <CRow class="bottomButton">
                <CCol sm="2"></CCol>
                <CButton
                    color="info"
                    size="sm"
                    class="buttonSize"
                    @click="selectedNext"
                >
                    CONTINUE
                </CButton>
                <CCol sm="2"></CCol>
            </CRow>
        </div>
        <div v-else>
            <CCol sm="10">
                <CRow class="displayFlex">
                    <h4>Employee Details</h4>
                    <span class="EditButton">Edit</span>
                </CRow>
            </CCol>
            <CCol>
                <CDataTable
                    :items="employeeDetails"
                    :fields="items"
                    :column-filter="false"
                    hover
                    pagination
                    addTableClasses="table table-borderless table-hover table-sm table-condensed table-class"
                    style="width: 85%"
                    class="mt-1"
                >
                </CDataTable>
            </CCol>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as database from '../../services/database-connectivity';
import { storeData } from '../../store';

const items = [
    { key: 'key', label: '' },
    { key: 'value', label: '' }
];

export default {
    created: async function() {
        if (
            storeData.employeeDetails != null &&
            storeData.employeeDetails.length > 0
        ) {
            this.employeeDetails = storeData.employeeDetails;
            // this.isSubmitted = true;
        }
    },
    data() {
        return {
            isBasic: true,
            isBankInfo: false,
            isOthers: false,
            items,
            isEmployee: true,
            isLoading: false,
            employeeDetails: [],
            employeeId: 0,
            employerId: '',
            walletAddress: '',
            isSubmitted: false,
            amount: '',
            dateOfBirth: '',
            name: '',
            email: '',
            joinDate: '',
            jobTitle: '',
            department: '',
            selectedManager: '',
            Country: '',
            selectedPaymentFrequency: '',
            selecetedCurrency: '',
            onManagerChange(e) {
                this.selectedManager = e.target.value;
            },
            onCountryChange(e) {
                this.Country = e.target.value;
            },
            onPaymentFrequencyChange(e) {
                this.selectedPaymentFrequency = e.target.value;
            },
            onPreferredCurrencyChange(e) {
                this.selecetedCurrency = e.target.value;
            }
        };
    },
    components: {
        Loading
    },
    methods: {
        async selectedNext() {
            if (this.isBasic) {
                this.isBasic = false;
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false;
                    this.isBankInfo = true;
                }, 2000);
                this.isOthers = false;
            } else if (this.isBankInfo) {
                this.isBankInfo = false;
                this.isBasic = false;
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false;
                    this.isOthers = true;
                }, 2000);
            } else {
                this.isBankInfo = false;
                this.isBasic = false;
                this.isOthers = true;
                this.isLoading = true;
                var response = await database.insertEmployee(
                    parseInt(this.employeeId),
                    this.employerId,
                    this.walletAddress,
                    this.name,
                    this.Country,
                    this.dateOfBirth,
                    this.department,
                    this.email,
                    this.isEmployee,
                    this.jobTitle,
                    this.joinDate,
                    this.selectedPaymentFrequency == ''
                        ? 'Daily'
                        : this.selectedPaymentFrequency,
                    this.selecetedCurrency == ''
                        ? 'ETH'
                        : this.selecetedCurrency,
                    this.amount
                );
                this.isLoading = false;
                console.log('data response', response);
                this.employeeDetails.push(
                    { key: 'Employee type', value: this.isEmployee },
                    { key: 'Name', value: this.name },
                    {
                        key: 'Joining date',
                        value: this.joinDate
                    },
                    {
                        key: 'Job Title',
                        value: this.jobTitle
                    },
                    {
                        key: 'Select Country',
                        value: this.Country == '' ? 'India' : this.Country
                    },
                    {
                        key: 'Employee Id',
                        value: this.employeeId
                    },
                    {
                        key: 'Department',
                        value: this.department
                    },
                    {
                        key: 'Manager',
                        value:
                            this.selectedManager == ''
                                ? 'Amal'
                                : this.selectedManager
                    },
                    {
                        key: 'Wallet Address',
                        value: this.walletAddress
                    },
                    {
                        key: 'Payment frequency',
                        value:
                            this.selectedPaymentFrequency == ''
                                ? 'Daily'
                                : this.selectedPaymentFrequency
                    },
                    {
                        key: 'Preferred currency',
                        value:
                            this.selecetedCurrency == ''
                                ? 'ETH'
                                : this.selecetedCurrency
                    },
                    {
                        key: 'Date of birth',
                        value: this.dateOfBirth
                    }
                );
                this.isSubmitted = true;
                storeData.employeeDetails = this.employeeDetails;
            }
        }
    }
};
</script>
<style scoped>
.topContainer {
    height: 120px;
    color: white;
    border: none;
    background-color: #272f51;
    font-size: 21px;
}
.headerText {
    font-size: 30px;
}
.bottomButton {
    height: 100px;
}
.buttonSize {
    height: 50px;
    padding: 10px 40px;
    margin-left: 15px;
}
.cardBody {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}
.whiteRuler {
    background-color: white;
}
.checkBox {
    padding: 10px;
    padding-bottom: 20px;
}
.selectClass {
    width: 100%;
    color: white;
    background-color: #272f51;
    padding: 10px;
    margin-bottom: 20px;
}
.blueRuler {
    background-color: #5a99e8;
}
.blueText {
    color: #5a99e8;
    text-align: center;
}
.whiteText {
    color: white;
    text-align: center;
}
.space20pad {
    padding-top: 10px;
    padding-left: 10px;
}
.textStyle {
    font-size: 20px;
}
.checkBox {
    padding: 10px;
    padding-bottom: 20px;
}
</style>
